import { DropDownOption } from "./primereact";

export class BusinessHomeProfile {
  homeId: string | undefined;

  businessName: string | undefined;
  facilityType: string | undefined;

  providerFirstName: string | undefined;
  providerLastName: string | undefined;
  providerEmail: string | undefined;
  providerPhoneNumber: string | undefined;

  businessPhoneNumber: string | undefined;
  businessFaxNumber: string | undefined;
  businessAddressLine1: string | undefined;
  businessAddressLine2: string | undefined;
  formattedAddress: string | undefined;

  city: string | undefined;
  state: string | undefined;
  country: string | undefined;
  zipcode: string | undefined;
  latitude: string | undefined;
  longitude: string | undefined;
  routeId: string | undefined;
  noOfBeds: number | undefined;
  active: boolean = true;
  isWebsiteActive: boolean | undefined;
  websiteUniqueName: string | undefined;
  websiteDraftTemplateKey: string | undefined;
  websitePublishedTemplateKey: string | undefined;
  accessType: string | undefined;
  accessLabel: string | undefined;

  images: string[] | undefined;

  createdAt: string | undefined;
  createdBy: string | undefined;
  modifiedAt: string | undefined;
  modifiedBy: string | undefined;
}

export interface Column {
  field: string;
  label: string;
}

export interface RowData {
  [key: string]: any;
  profileImage?: string;
}

export interface TableProps {
  isAddButton: boolean;
  columns: Column[];
  data: RowData[];
  onEdit?: (row: RowData) => void;
  onUpload?: (row: RowData) => void;
  onUserReview?: (row: RowData) => void;
  onDelete?: (row: RowData) => void;
  onDownLoad?: (row: RowData) => void;
  onAdd?: () => void;
  title: string;
  notFoundTitle: string;
  isLoading?: boolean;
}

export type InquiryType = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  subject: string;
  message: string;
  rangeId: string;
  routeId: string;
  createdAt: string;
  modifiedAt: string;
  modifiedBy: string;
};

export type ServiceData = {
  createdAt: string;
  id: string;
  modifiedAt: string;
  modifiedBy: string;
  serviceName: string;
};

export class HomeHiringJobProfile {
  homeId: string | undefined;

  lookingToHire: boolean = false;
  jobTitle: string | undefined;
  jobDescription: string | undefined;

  skills: DropDownOption[] | undefined;
  certifications: DropDownOption[] | undefined;

  expectedSalaryRange: string | undefined;

  relocationWillingness: boolean = false;
  livingArrangements: boolean = false;

  availableDayShifts: DropDownOption[] | undefined;
  availableNightShifts: DropDownOption[] | undefined;

  joiningDate: string | undefined;

  createdAt: string | undefined;
  createdBy: string | undefined;
  modifiedAt: string | undefined;
  modifiedBy: string | undefined;
}

export interface HomeHiringJobProfileSearch {
  latitude: string | undefined;
  longitude: string | undefined;
  radiusInMiles: number | undefined;
  limit: number | undefined;
  lastEvaluatedKey: string | undefined;
}

export interface ListingSearchInput {
  latitude: string | undefined;
  longitude: string | undefined;
  radiusInMiles: number | undefined;
  limit: number | undefined;
  lastEvaluatedKey: string | undefined;
}

export class ClientAvailabilityProfile {
  homeId: string | undefined;

  description: string | undefined;
  noOfRoomsAvailable: number | undefined;

  acceptanceCriterias: DropDownOption[] | undefined;
  nonAcceptanceCriterias: DropDownOption[] | undefined;

  createdAt: string | undefined;
  createdBy: string | undefined;
  modifiedAt: string | undefined;
  modifiedBy: string | undefined;
}

export class WebsiteInquiry {
  inquiryId: string | undefined;

  homeId: string | undefined;
  fullName: string | undefined;
  email: string | undefined;
  phoneNumber: string | undefined;
  message: string | undefined;
  inquiryType: string | undefined;
  dismissed: boolean = false;

  createdAt: string | undefined;
  modifiedAt: string | undefined;
}
